export const tagTypes = [
    "GET_ALL_TABLE_RECORDS",
    "GET_ALL_SCHEME_INTEREST",
    "ME",
    "LOGIN_USER",
    "USER_DETAILS",
    "USER_TYPE_DETAILS",
    "GET_USER_DETAILS",
    "RESET_PASSWORD",

    "GET_PM_KISAN_DATA",
    "GET_DISTRICT_LIST",
    "GET_RD_BLOCK_LIST",
    "GET_GRAM_PANCHAYAT_LIST",

    "WEATHER_STATION_LIST",
    "WEATHER_STATION_CREATE",
    "WEATHER_STATION_SINGLE",
    "WEATHER_STATION_UPDATE",

    "REFRESH_SINGLE_CITY_WEATHER",
    "REFRESH_CITY_WEATHER",
    "GET_CITY_WEATHER_LIST",
    
    "STATION_DATA_LIST",
    "STATION_DATA_REFRESH",
    "STATION_DATA_ALL_LIST",
    "DESIGNATION_DATA_LIST",
    "DESIGNATION_DATA_SINGLE",
    "GET_ALL_USER",

    "CREATE_SDSCO",
    "GET_ALL_SDSCO",
    "GET_SINGLE_SDSCO",
    "UPDATE_SDSCO",

    "GET_ALL_SOIL_SECTION",
    "CREATE_SOIL_SECTION",
    "GET_SINGLE_SOIL_SECTION",
    "UPDATE_SINGLE_SOIL_SECTION",

    "GET_ALL_CROP_MASTER",

    "GET_ALL_CROP_ADVISORY",
    "CREATE_CROP_ADVISORY",
    "GET_SINGLE_CROP_ADVISORY",
    "UPDATE_SINGLE_CROP_ADVISORY",

    "GET_ALL_FARMER_INTEREST",

    "UPDATE_GRIEVANCE",
    "GET_ALL_GRIEVANCE",

    "GET_SINGLE_CREATOR",
    "UPDATE_CREATOR",
    "CREATE_CREATOR",
    "GET_ALL_CREATOR",
    "GET_REVIEW_LOG",

    "GET_ALL_SCHEME_LIST",

    "GET_ALL_CROP_DISEASE_LOG",

    "GET_ALL_FARMER_LIST",

    /*AGRI STACK*/
    "GET_ALL_OWNER_CODE",
    "GET_ALL_LAND_LIST",
    /*END HERE*/
    
    /*Village*/
    "GET_ALL_VILLAGE_LIST"
    /*END HERE*/
  ]